import React, { Component } from 'react';
import './Tabs.css';


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={`${item.groupId+`id`+item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" :"nav-link"} href={`#${item.groupId+`id`+item.segmentId}`} aria-controls={`${item.groupId+`id`+item.segmentId}`} aria-selected="true">{item.groupName+` - `+item.segmentName} <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteTab(item)}
                ></i></a>
            </li>)
        });

        let tabsContent = this.props.tabs.map((tabItem, key) => {

            const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            const segmentId = this.props.tabs.find(r => r.segmentId === tabItem.segmentId).segmentId;

            let data = this.props.positioningData.find(r => r.segmentId === segmentId &&  r.groupId === groupId)

            return (
                <div id={groupId+`id`+segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content": "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-4">
                            <div className='form-group'>
                                <label>Target Segment or Stakeholder</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.forWhome : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'forWhome', data, groupId, segmentId)}/>
                                </div>

                            </div>
                            <div className='form-group'>
                                <label>Customers Core Needs</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.brand : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'brand', data, groupId, segmentId)} />
                                </div>
                            </div>
                            <div className='form-group'>
                                <label>Our Product or Offering Name</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.isThe : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'isThe', data, groupId, segmentId)} />
                                </div>
                            </div>
                            <div className='form-group'>
                                <label>Competitive Frame of Reference</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.that : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'that', data, groupId, segmentId)} />
                                </div>
                            </div>
                            <div className='form-group'>
                                <label>Point of Differentiation</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.because : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'because', data, groupId, segmentId)} />
                                </div>
                            </div>
                            <div className='form-group'>
                                <label>Our Supporting Information</label>
                                <div className='input-box'>
                                    <textarea type='text' value={data ? data.soThat : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'soThat', data, groupId, segmentId)} />
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-4">
                            <div className="label-description"> <strong>WHO :</strong> Describe the segment(s) of the market we are trying to influence.</div>
                            <div className="label-description"> </div>
                            <div className="label-description"> <strong>WHAT :</strong>  The "consideration set" for our product, based on what it does and other treatments available (including substitutes outside our category).</div>
                            <div className="label-description"> <strong>WHAT :</strong>  The visible, tangible benefit that is UNIQUELY delivered by our product. This should not change unless the criteria for repositioning are met.</div>
                            <div className="label-description"> <strong>HOW :</strong>  Specific product attributes that support the unique benefit. May evolve over time as additional data becomes available or due to significant, unanticipated changes in the marketplace.</div>
                            <div className="label-description"> <strong>WHY :</strong>   Link to higher order benefit / value proposition. It should tie back to brand identity (ideally brand essence).</div>
                        </div> */}
                    </div>

                </div>
            )

        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    <li className="nav-item">
                        <a  id='plusTab' onClick={() => this.props.createTabModal()}
                        ><i className="fa fa-plus plusbtn plus-icon"></i></a>
                    </li>
                    {tabs}
                    {/* { !_.isEmpty(this.props.attractivnessData.Items) && this.addTabs(this.props.attractivnessData.Items[0].data)} */}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/PositioningStatement/FillInItems/Tabs/Tabs.jsx